import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../modules/utility';
import { showErrors } from '../modules/general';

const getScheduleConfigs = ({ callback = _.noop } = {}) => (dispatch) => {
	apiFetch({ method: 'scheduleConfig.get', params: {}, dispatch, callback });
};

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ getScheduleConfigs, showErrors }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps);
